<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :initialFilters="filters"
  >
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="2" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="3" class="text-left title"><strong>{{ this.groundsTotalArea | formatNumber }} ha</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Área Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.groundsTotalArea | formatNumber }} ha</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      originalIndexItemsLength: 0,
      loading: true,
      pageLoading: false,
      totalItems: 0,
      groundsTotalArea: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Nome da Área", align: "left", sortable: true, value: "name"},
        { text: "Área", align: "left", sortable: true, value: "area" },
        { text: "Tipo", align: "left", sortable: true, value: "typeName", filter_value: "type" },
        { text: "Ativo", align: "left", sortable: true, value: "enabled" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'area', mask: 'number_unit', unit: 'ha' }, 
        { field: "enabled", mask: "nice_boolean"},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [{
        field: "enabled",
        fieldValues: [true],
        key: 0,
        operator: "in",
        type: "boolean"
      }], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Área"
    },
    modelNamePlural: {
      type: String,
      default: "Áreas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_GROUNDS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.grounds = response.data.accountContext.allGrounds;
          // console.log("All GROUNDS", this.grounds);

          this.indexItems = response.data.accountContext.groundsIndex.grounds; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.originalIndexItemsLength = this.indexItems.length;
          this.totalItems = response.data.accountContext.groundsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.groundsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.groundsIndex.serverFields; // seta os campos que podem ser filtrados

          this.groundsTotalArea = 0;
          for (var ground in this.indexItems) {
            this.groundsTotalArea += this.indexItems[ground].area;
          }
          this.groundsTotalArea = _.round(this.groundsTotalArea, 2);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
      if (this.originalIndexItemsLength == 0) {
        window.location.reload();
      }
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_GROUNDS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      groundsIndex(input: $input){
        count
        typeOperators
        serverFields      
        grounds {
          id
          code
          type
          typeName
          name
          area
          price
          enabled
          rentalPrice
          opportunityCost
          canBeDeleted
          undeletabilityReasons
          address {
            id
            street
          }
          addressAttributes {
            id
            street
          }
        }
      }
    }  
  accountContext {
    allGrounds {
      id
      code
      type
      typeName
      name
      area
      price
      enabled
      rentalPrice
      opportunityCost
      canBeDeleted
      undeletabilityReasons
      address {
        id
        street
      }
      addressAttributes {
        id
        street
      }
    }
  }
}
`;

const SELECT_GROUND_MUTATION = gql `
  mutation($groundId: ID!) {
    selectGround(groundId: $groundId) {
      ground {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
